import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class UnauthorizedException extends MainException implements ExceptionContract {
    public static readonly ERROR_CODE: number = 401;

    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, UnauthorizedException.ERROR_CODE, data);
        this.name = 'UnauthorizedException';
    }
}
